import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

export class Advantage extends Component {
    state = {
        teacherData: []
    }
    static propTypes = {
        course: PropTypes.object.isRequired,
        actions: PropTypes.object.isRequired,
    };

    componentWillMount() {
        let _this = this;
        this.props.actions.fetchGetTeacherList({
            PageSize: 2,
            PageIndex: 1,
            PageStatus: 1,
            Discipline_ID: 0
        }).then(res => {
            if (res.SuccessResponse) {
                _this.setState({
                    teacherData: res.Data
                })
            }
        });
    }
    render() {
        let { teacherData } = this.state;
    return (
      <div className="topic-advantage">
            <div className="header">
                <div className="header_box">
                    <div className="logo"><img src={require('../../images/yx_logo.jpg')} /><span>网校优势</span></div>
                    <div className="phone">客服热线: 17375813702</div>
                </div>
            </div>
            <div className="banner">
                <div className="position">
                    <div className="action_box1">
                        <ul>
                            <li>
                                <div className="linuber">10<b>年</b></div>
                                <span>深耕教育行业</span>
                                <p>2011年-2019年，8年时间，深耕在线教育行业，从课程到服务，从学历提升到职业资格考证，我们坚持将学生放在第一位。</p>
                            </li>
                            <div className="box1_height"></div>
                            <li>
                                <div className="linuber">1000<b className="b">+</b></div>
                                <span>教研服务团队</span>
                                <p>网校不断壮大师资队伍，以科学的备考体系，完善的课程资源，PC+移动端便利的学习形式，助力学生学习更轻松。</p>
                            </li>
                            <div className="box1_height"></div>
                            <li>
                                <div className="linuber">720<b>天</b></div>
                                <span>课程保障周期</span>
                                <p>完备的课程保障体系更好的解决学生的后顾之忧，720天的超长保障周期，协议可退费，老师1V1督学以及报考指导等。</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="action">
                <div className="action_box2">
                    <div className="action_box2_cont">
                        <h1><span>"</span>权益保障<span>"</span></h1>
                        <div className="action_box2_title">百分网完备助学服务 助力您无忧取证</div>
                        <div className="guarantee">
                            <div className="guarantee_left">
                                <div className="guarantee_box1">
                                    <h2>学习保障</h2>
                                    <ul>
                                        <li>考试未过可免费重学</li>
                                        <li className="li2">课程七天无理由退换</li>
                                    </ul>
                                </div>
                                <div className="guarantee_box2">
                                    <h2>权威题库</h2>
                                    <ul>
                                        <li>历年真题精华</li>
                                        <li className="li2">专业答案解析</li>
                                        <li className="li3">命题规律解析</li>
                                        <li className="li2 li3">新增考点预测</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="guarantee_right">
                                <h2>教学服务</h2>
                                <div className="guarantee_right_box">
                                    <p>
                                        1. 考试重点消息短信通知<br />
                                        2. 考前救命小宝典<br />
                                        3. 量身定制专属学习计划<br />
                                        4. 精制版课程讲义，免费下载<br />
                                        5. 老师24小时内处理所有答疑
                                    </p>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="action_box3">
                    <div className="action_box3_cont">
                        <h1><span>"</span>配套服务<span>"</span></h1>
                        <div className="action_box3_title">完善的学习辅助 让学习更轻松</div>
                        <div className="service">
                            <ul>
                                <li>
                                    <div className="action_box3_left">移动学习</div>
                                    <div className="action_box3_right">
                                        学在掌心，随时随地，想学就学<span>20000+</span> 丰富题库，海量资源，知识点尽在掌握
                                    </div>
                                </li>
                                <li className="service_li1">
                                    <div className="action_box3_left">直播+录播</div>
                                    <div className="action_box3_right">
                                        自主研发直播教学系统，实现学员与老师实时互动，以<span>“直播+录播”</span>突破线上学习互动弱的难题。
                                    </div>
                                </li>
                                <li className="service_li2">
                                    <div className="action_box3_left">备考体系</div>
                                    <div className="action_box3_right">
                                        不是单一的教材精讲，而是更合理的 <span>基础、强化、冲刺 </span> 三大备考体系。
                                    </div>
                                </li>
                                <li className="service_li1 service_li2">
                                    <div className="action_box3_left">1V1督学</div>
                                    <div className="action_box3_right">
                                        <span>1对1</span>分析学习情况，做阶段学习计划，明确学习方向，掌控学习节奏。
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="action_box4">
                    <div className="action_box4_cont">
                        <h1><span>"</span>师资团队<span>"</span></h1>
                        <div className="action_box4_title">层层筛选 甄选优秀名师</div>
                        <div className="team">
                            <ul>
                                {teacherData && teacherData.map(item => <li key={item.ID}>
                                    <div className="boy"><img src={item.ImagePhoto} alt="" /></div>
                                    <div className="li_box">
                                        <div className="li_box_t"><span>{item.Name}</span>{item.Title}</div>
                                        <p>{item.Introduction}</p>
                                    </div>
                                </li>)}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bottom">
                <div className="bottom_box">
                    <ul className="bottom_ul">
                        <li className="bottom_li">
                            <img src={require('../../images/icon1.png')} />
                            <h2>职业资格</h2>
                            <ul>
                                <li>教师资格</li>
                                <li>人力资源</li>
                                <li>消防工程</li>
                                <li>学位英语</li>
                            </ul>
                        </li>
                        <li className="bottom_li">
                            <img src={require('../../images/icon2.png')} />
                            <h2>建筑学院</h2>
                            <ul>
                                <li>一级建造</li>
                                <li>二级建造</li>
                                <li>一级消防</li>
                                <li>一级造价</li>
                                <li>二级造价</li>
                            </ul>
                        </li>
                        <li className="bottom_li">
                            <img src={require('../../images/icon3.png')} />
                            <h2>财会学院</h2>
                            <ul>
                                <li>初级会计</li>
                                <li>中级会计</li>
                                <li>注册会计</li>
                                <li>初级经济</li>
                                <li>中级经济</li>
                                <li>注册税务</li>
                            </ul>
                        </li>
                        <li className="bottom_li">
                            <img src={require('../../images/icon4.png')} />
                            <h2>金融学院</h2>
                            <ul>
                                <li>银行从业</li>
                                <li>证券从业</li>
                                <li>基金从业</li>
                                <li>期货从业</li>
                            </ul>
                        </li>
                        <li className="bottom_li">
                            <img src={require('../../images/icon5.png')} />
                            <h2>医药学院</h2>
                            <ul>
                                <li>执业药师</li>
                                <li>护士资格</li>
                                <li>健康管理</li>
                            </ul>
                        </li>
                        <li className="bottom_li">
                            <img src={require('../../images/icon6.png')} />
                            <h2>学历提升</h2>
                            <ul>
                                <li>自考</li>
                                <li>成考</li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
      </div>
    );
  }
}


/* istanbul ignore next */
function mapStateToProps(state) {
    return {
        course: state.course,
    };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ ...actions }, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Advantage);



// WEBPACK FOOTER //
// ./src/features/topic/Advantage.js